import {Component, inject, OnInit, signal} from "@angular/core";
import {SnackbarComponent} from "@common/ui/snackbar/snackbar.component";
import {TranslateModule} from "@ngx-translate/core";
import {MAT_SNACK_BAR_DATA} from "@angular/material/snack-bar";
import {Translations} from "@translations";

export interface SuccessSnackbarData {
	translationKey?: string | undefined;
	duration: number;
}

@Component({
	selector: "sim-success-snackbar",
	imports: [SnackbarComponent, TranslateModule],
	templateUrl: "./success-snackbar.component.html",
	styleUrl: "./success-snackbar.component.scss",
})
export class SuccessSnackbarComponent implements OnInit {
	// Properties
	protected successMessage = signal<string>(Translations.GENERIC_SUCCESS_MSG);

	// Injections
	protected readonly data = inject<SuccessSnackbarData>(MAT_SNACK_BAR_DATA);

	public ngOnInit(): void {
		if (this.data.translationKey) {
			this.successMessage.set(this.data.translationKey);
		}
	}
}
